export class Stack {
    constructor(items = []) {
        this.items = items;
    }
    push(item) {
        return new Stack([item, ...this.items]);
    }
    pop(asLongAs) {
        do {
            this.items.shift();
        } while (this.current && (asLongAs === null || asLongAs === void 0 ? void 0 : asLongAs(this.current)));
        return new Stack(this.items);
    }
    get current() {
        return this.items[0];
    }
}
